var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M361.823 295.512C505.264 262.805 514.297 29.3313 597.094 6.56237C425.295 -21.7689 343.834 52.1741 299.215 214.004C254.989 54.7699 168.657 -25.2547 4.87035 7.08159C93.4799 29.3313 85.8607 251.829 236.214 295.438C120.268 295.438 111.705 562.509 0 593.436C174.863 623.177 258.053 534.103 299.215 377.688C341.399 533.881 435.428 622.806 600 594.919C490.416 584.462 507.699 295.438 361.744 295.438",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmask);
export default __webpack_public_path__ + "static/media/X mask.5afe92d83d453f2ef53e6a1e20aca5fd.svg";
export { ForwardRef as ReactComponent };